import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import SecurityCoverPageUI from './SecurityCoverPageUI.js'

class SecurityCoverPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
          errorList: null,
          loan: null,
          loanInterestRate: null
        }
    }

    render() {
        return (
            <SecurityCoverPageUI
                context={this.props.context}
                loan={this.state.loan}
                errorList={this.state.errorList}
                loanInterestRate={this.state.loanInterestRate}
                onRefreshClick={this.onRefreshClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getLoan(context)
        this.getInterestRate(context)
    }

    getLoan(context) {
      let cacheManager = new CacheManager({
        resource: `/api/su/loans/${this.props.match.params.loanId}`,
        cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
        callback: this.getLoanCallback,
        ttlInSecs: 600
      })
      cacheManager.getObject2(context)
    }

    getLoanCallback = (response) => {
      let context = this.props.context
      this.setState({errorList: response.errorList, loan : response.loan})
    }

    getInterestRate(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/${this.props.match.params.loanId}/interestRate`,
            cacheKey: CacheKeys.InterestRate(this.props.match.params.loanId),
            callback: this.getInterestRateCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getInterestRateCallback = (response) => {
        this.setState({ loanInterestRate: response.loanInterestRate, errorList: response.errorList })
    }

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.InterestRate(this.props.match.params.loanId))
        this.setState({ loanInterestRate: null },
            this.getInterestRate(context)
        )
    }

}

export default withRouter(SecurityCoverPageSF)
